import { useCallback, useMemo } from 'react';
import { useGetUnitsByAccountQuery } from '@/api/recalc/endpoints/unitsApiSlice';
import useStableSearchParams from '@/hooks/useStableSearchParams';
import { useSelector } from 'react-redux';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';

function useSelectedUnits() {
  const accountId = useSelector(getSelectedAccount).AccountId;
  const [searchParams, setSearchParams] = useStableSearchParams();

  const { data: units, isSuccess: unitsOk } = useGetUnitsByAccountQuery(
    accountId,
    { skip: !accountId },
  );

  // --- State from URL ---
  const selectedUnitIds = searchParams.get('units');

  // --- Setters that update the URL ---
  const setSelectedUnitIdsInUrl = useCallback(
    (ids) => {
      setSearchParams((prev) => {
        const nextParams = new URLSearchParams(prev);
        if (ids && ids.length) {
          nextParams.set('units', ids);
        } else {
          nextParams.delete('units');
        }
        return nextParams;
      });
    },
    [setSearchParams],
  );

  const selectedUnits = useMemo(() => {
    if (!unitsOk || !units || !units.length || !selectedUnitIds) return [];
    const set = new Set(selectedUnitIds.split(',').map((s) => Number(s)));
    return units.filter((u) => set.has(Number(u.UnitId)));
  }, [unitsOk, units, selectedUnitIds]);

  return [selectedUnits, setSelectedUnitIdsInUrl];
}

export default useSelectedUnits;
